export enum UserTypes {
  Administrador = 'administrador',
  Superusuario = 'superusuario',
  Usuario = 'usuario',
  SoloLectura = 'solo-lectura',
  Invitado = 'invitado',
}
